/**
 * Created by istvan.rozsa on 2017. 04. 25..
 */

import sendInvoiceController from './send-email-controller';

export default function (app) {
	app.component('sendEmailForm', {
		bindings: {
			selectedDetailsTab: '@',
			sendEmailSubmit: '&',
			cancelCallback: '&',
			attachmentUrl: '=',
			docid: '@',
			docName: '@?',
			goBackToPreview: '&?',
			copyOfEmailData: '=?',
			partnerPrimaryContactEmail: '<'
		},
		templateUrl: 'common/send-email',
		controller: ['COMMON_CONSTS', 'DOCUMENT_TYPE', '$filter', 'frameContext', 'EndPointProtection', sendInvoiceController]
	});
}
